export function handleApiResponse<T>(
  res: any,
  { showErrorAlert, topAlert }: { showErrorAlert: Function; topAlert: Function }
): T | null {
  if (res.success) {
    if (res.message) {
      topAlert(res.message, "success", 1000);
    }
    return res.data ?? res.success;
  } else {
    showErrorAlert(res.error, res.error_message);
    return null;
  }
}